import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

export const getPreferredMsalAccount = (
  instance: IPublicClientApplication,
  accounts: AccountInfo[]
): AccountInfo | null => {
  return instance.getActiveAccount() ?? accounts[0] ?? null;
};

export const ensureActiveMsalAccount = (
  instance: IPublicClientApplication,
  accounts: AccountInfo[]
): AccountInfo | null => {
  const preferredAccount = getPreferredMsalAccount(instance, accounts);

  if (preferredAccount && !instance.getActiveAccount()) {
    instance.setActiveAccount(preferredAccount);
  }

  return preferredAccount;
};
